module.exports = __webpack_public_path__ + "img/rota-volta.08bb73bd.jpg";